import defineComponent from 'flight';
import History from 'static/script/utils/history';
import $ from 'jQuery';
import Logger from 'static/script/utils/logger';
import loadModules from '../../pages/load-modules';

function Navigation() {

    this.defaultAttrs({
        pushStateSelector: 'a[data-nav]',
        elementsToReplace: '[data-replace-with-pjax]',
        headers: 'head',
        body: 'body',
        pageTitle: 'title',
        initialScrollPosition: '[data-initial-scroll]:visible'
    });

    let scrollPositions = {};

    this._skipPjax = function (e) {
        /* jshint maxcomplexity:7 */
        let theUserWantsToOpenTheLinkInANewTab = e.which > 1 || e.metaKey || e.ctrlKey || e.keyCode > 1 || e.shiftKey;
        return theUserWantsToOpenTheLinkInANewTab;
    };

    this._setupScrollToCurrentPosition = function () {
        return {
            position: $(window).scrollTop()
        };
    };

    this._setupScrollToId = function (id, elm) {
        let elementOffsetFromWindowTop = elm.offset().top - $(window).scrollTop();

        return {
            id: id,
            position: elementOffsetFromWindowTop
        };
    };

    this._storeScrollPosition = function (elm) {
        let id = elm.attr('id');
        let scroll = id ? this._setupScrollToId(id, elm) : this._setupScrollToCurrentPosition();
        scrollPositions[location.href] = scroll;
    };

    this._scrollToId = function (id, position) {
        let $element = $('#' + id);

        if ($element.length === 0)  {
            return;
        }

        let scrollToY = $element.offset().top - position,
            resetScroll = 0;

        if (scrollToY > 0) {
            resetScroll = scrollToY - 1;
        }

        $(window).scrollTop(resetScroll); // Chrome gets upset when doing just one "scrollTop"
        $(window).scrollTop(scrollToY);
    };

    this._scrollToPosition = function (position) {
        let resetScroll = 0;

        if (position > 1) {
            position = position - 1;
            resetScroll = position - 1;
        }

        $(window).scrollTop(resetScroll); // Chrome gets upset when doing just one "scrollTop"
        $(window).scrollTop(position);
    };

    this._scrollToTopOrInitialScroll = function () {
        let scrollPosition = this.select('initialScrollPosition');
        if (scrollPosition.length > 0) {
            this._scrollToPosition(scrollPosition.offset().top + 1);
        } else {
            this._scrollToPosition(0);
        }
    };

    this._restoreScrollPosition = function (initData) {
        if (!initData.isPopState && !initData.preserveScrollPosition) {
            this._scrollToTopOrInitialScroll();
            return;
        }

        let scrollPosition = scrollPositions[location.href];
        if (scrollPosition) {
            if (scrollPosition.id) {
                this._scrollToId(scrollPosition.id, scrollPosition.position);
            }
            else if (scrollPosition.position) {
                this._scrollToPosition(scrollPosition.position);
            }
        }
    };

    this.navigate = function (e) {
        if (this._skipPjax(e)) {
            return;
        }

        let target = $(e.target);
        let link = target.closest(this.attr.pushStateSelector);

        if (link.length > 0 && !e.isDefaultPrevented()) {
            e.preventDefault();
            e.stopImmediatePropagation();

            if (this._isBadLink(link)) {
                this.logInfo('The bad link html: ' + link[0].outerHTML, 'Failed to navigate with pjax. ');
                return;
            }

            this._storeScrollPosition(link);

            this.trigger('ui:navigate', { href: link.attr('href'), target: link });
        }
    };

    this._isBadLink = function (link) {
        return !link.attr('href') || link.attr('href').length === 0 || link.attr('href') === 'undefined';
    };

    this.updatePage = function (e, initData) {
        this.trigger('ui:before-page-change', initData);
        this.trigger('ui:teardown', initData);

        let $html = $(initData.viewHtml);

        this.select('elementsToReplace').each(function () {
            let $this = $(this);
            let id = $this.attr('id');
            let $replacement = $html.find('#' + id);
            $this.html($replacement.html());
        });

        this.select('pageTitle').text(initData.title);
        this._updateActivePageClass(initData);
        //LOAD MODULES HERE BRO.
        loadModules(initData);
        this.trigger('ui:navigation:after-page-change', initData);
        this._restoreScrollPosition(initData);
    };

    this._updateActivePageClass = function (initData) {
        this.select('body').attr('class', initData.bodyClasses);
    };

    this.after('initialize', function () {
        this.on('click', this.navigate);
        this.on('data:navigation:after-page-load', this.updatePage);
    });

}

export default Logger.mixin(Navigation);




// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/navigation.js